import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_HISTORY: GlameraIconDefinition = {
  name: 'history',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-history-arc" d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
    <path class="glm-history-arrow" d="M3 3v5h5"></path>
    <path class="glm-history-minute" d="M12 7v5"></path>
    <path class="glm-history-hour" d="M12 12l4 2"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-history-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './history.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HistoryIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_HISTORY;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
